import { onBeforeUnmount, onMounted } from "vue";

/**
 * Overlays Element Plus montés dans <body> : modales, toasts, messages, menus
 * déroulants (conteneur des poppers), masque de chargement plein écran.
 */
const OVERLAY_SELECTOR = [
  ".el-overlay",
  ".el-notification",
  ".el-message",
  ".el-loading-mask",
  '[id^="el-popper-container"]',
].join(",");

/**
 * L'outil dessin est sombre, mais la page reste en data-bs-theme="light" : ses
 * barres et volets s'appuient sur `text-white`, que le dark mode de l'app
 * redéfinit en gris foncé. Seuls les overlays passent en sombre — on pose
 * data-bs-theme="dark" sur leur racine, directement sous <body>, le temps de
 * l'outil.
 */
export function useCanvasOverlayTheme() {
  const marked = new Set<Element>();

  const mark = (el: Element) => {
    if (!el.matches(OVERLAY_SELECTOR) || el.hasAttribute("data-bs-theme")) return;
    el.setAttribute("data-bs-theme", "dark");
    marked.add(el);
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => node instanceof Element && mark(node));
    }
  });

  onMounted(() => {
    document.documentElement.classList.add("canvas-theme");
    Array.from(document.body.children).forEach(mark);
    observer.observe(document.body, { childList: true });
  });

  onBeforeUnmount(() => {
    observer.disconnect();
    marked.forEach((el) => el.removeAttribute("data-bs-theme"));
    marked.clear();
    document.documentElement.classList.remove("canvas-theme");
  });
}
